import React from "react";

export default function FullPageLoaderMarkAtt() {
  return (
    <div className="loader bg-blur" style={{ flexDirection: "column", zIndex: 9999 }}>
      <figure className="iconLoaderProgress" style={{ margin: 0 }}>
        <svg className="iconLoaderProgressFirst" width="240" height="240">
          <circle cx="120" cy="120" r="100"></circle>
        </svg>

        <svg className="iconLoaderProgressSecond" width="240" height="240">
          <circle cx="120" cy="120" r="100"></circle>
        </svg>
      </figure>
      <p className="fw-semibold text-primary" style={{ zIndex: 9999, fontSize: "1.5rem", marginTop: "50px" }}>
        Updating attendance records...
      </p>
    </div>
  );
}
